module.exports = __webpack_public_path__ + "static/media/icon_midia_dinamica.a9ffb799.svg";